import { makeStyles } from "tss-react/mui"
import { TextField } from "@mui/material"
import React from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useDebouncedInput } from "../../../../../../shared/hooks/useDebouncedInput"

const useStyles = makeStyles()(() => ({
    textInput: {
        width: "15rem",
    },
}))

export function ReceiverInput({ value, onChange }: { value: string; onChange: (value: string) => void }) {
    const { classes } = useStyles()
    const { innerValue, setInnerValue } = useDebouncedInput(value, onChange)

    return (
        <LocalizedStrict id="support-messages-email-receiver-label" attrs={{ label: true, placeholder: true }}>
            <TextField
                className={classes.textInput}
                name="receiver"
                value={innerValue}
                placeholder="Enter email or user id"
                label="Receiver"
                onChange={(e) => setInnerValue(e.target.value)}
            />
        </LocalizedStrict>
    )
}
